<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="用户ID" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.userId" placeholder="请输入用户ID">
						</el-input>
					</el-form-item>
					<el-form-item label="登录名" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.username" placeholder="请输入登录名">
						</el-input>
					</el-form-item>
					<el-form-item  label="手机号" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.phone" placeholder="请输入手机号">
						</el-input>
					</el-form-item>

					<!-- <el-form-item label="收款类型" class='tiny '>
						<el-select v-model="searchInfo.cardType" placeholder="请选择" clear>
							<el-option key="-1" label="全部" value="">全部</el-option>
							<el-option key="1" label="银行卡" :value="1">银行卡</el-option>
							<el-option key="2" label="支付宝" :value="2">支付宝</el-option>
							<el-option key="3" label="微信" :value="3">微信</el-option>
						</el-select>
					</el-form-item> -->

					<el-form-item label="审核状态" class='tiny '>
						<el-select v-model="searchInfo.status" placeholder="请选择" clear>
							<el-option key="-1" label="全部" value="">全部</el-option>
							<el-option key="0" label="待审核" :value="0">待审核</el-option>
							<el-option key="1" label="待复核" :value="1">待复核</el-option>
							<el-option key="2" label="已完成" :value="2">已完成</el-option>
							<el-option key="3" label="已驳回" :value="3">已驳回</el-option>
							
						</el-select>
					</el-form-item>

					<!-- <el-form-item label="排序方式" class='tiny '>
						<el-select v-model="searchInfo.orderType" placeholder="默认申请时间升序" clear>
							<el-option key="0" label="申请时间降序" value="0">申请时间降序</el-option>
							<el-option key="1" label="提现总金额降序" value="1">提现总金额降序</el-option>
							<el-option key="2" label="提现总金额升序" value="2">提现总金额升序</el-option>
						</el-select>
					</el-form-item> -->
					<el-form-item label="充值时间">
						<div class="block">
							<el-date-picker v-model="searchInfo.timer" value-format="yyyy-MM-dd HH:mm:ss"
								type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期"
								:default-time="['00:00:00', '23:59:59']">
							</el-date-picker>
						</div>
					</el-form-item>

					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							<el-button type="primary" @click="downloadFile">
								导出
								<a href=""></a>
							</el-button>
						</template>
					</el-form-item>
					
				</el-form>
			</header>
		</div>
		<div style="margin-left: 20px;margin-bottom: 20px;">
			<span>充值总余额：{{amountSum}}元</span>
		</div>
		<el-table :data="payList.list" stripe style="width: 100%;" :header-cell-style="headClass"
			v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">

			<el-table-column prop="userId" label="用户ID" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="username" label="登录名" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="phone" label="手机号" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="name" label="资产名称" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="type" label="充值类别" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<div v-if="scope.row.type == 2">
						冲正
					</div>
					<div v-else>
						充值
					</div>
				</template>
			</el-table-column>

			<!-- <el-table-column prop="fees" label="手续费" align="center" :show-overflow-tooltip="true">
			</el-table-column> -->

			<el-table-column prop="amount" label="充值总数(￥)" align="center" :show-overflow-tooltip="true">
			</el-table-column>

			<el-table-column prop="status" label="审核状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<div v-if="scope.row.status == 0">待审核</div>
					<div  v-if="scope.row.status == 1">待复核</div>
					<div v-if="scope.row.status == 2">已完成</div>
					<div v-if="scope.row.status == 3">已驳回</div>
					
				</template>
			</el-table-column>

			
			<el-table-column label="查看凭证" align="center" prop="certificateImg" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="showContent(scope.row.certificateImg)">查 看
					</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="createTime" label="充值时间" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="checkDatetime" label="审核时间" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<div v-if="scope.row.updateTime">{{scope.row.updateTime}}</div>
					<div v-else>未审核</div>
				</template>
			</el-table-column>
			<el-table-column prop="checkBy" label="审核人" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
				<div v-if="scope.row.checkBy">{{scope.row.checkBy}}</div>
				</template>
			</el-table-column>
			<el-table-column prop="reviewBy" label="复核人" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
				<div v-if="scope.row.reviewBy">{{scope.row.reviewBy}}</div>
				</template>
			</el-table-column>
			<el-table-column prop="rechargeMemo" label="充值备注" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<div v-if="scope.row.rechargeMemo">{{scope.row.rechargeMemo}}</div>
					<div v-else>无</div>
				</template>
			</el-table-column>
			<!-- <el-table-column prop="updateTime" label="更新时间" align="center" :show-overflow-tooltip="true">
			</el-table-column> -->
			<el-table-column  label="操作"  fixed="right" align="center" width="140">
				<template slot-scope="scope">
				
					<!-- <el-button v-if="scope.row.status == 0 && isExamine" size="small" type="text"
						@click="open(scope.row.id,'sh')">审 核</el-button> -->
					<el-button v-if="scope.row.status == 1 && isRecheck" size="small" type="text"
						@click="open(scope.row.id,'fh')">复 核</el-button>
				<!-- 	<el-button v-if="scope.row.status == 0  && isExamine" size="small" type="text"
						@click="queryIntegralWithdrawal(scope.row.id,4,'驳 回')">驳 回</el-button> -->
						<el-button v-if="scope.row.status == 1  && isRecheck" size="small" type="text"
						@click="queryIntegralWithdrawal(scope.row.id,4,'驳 回')">驳 回</el-button>
					<div v-if="scope.row.status == 2">不可操作</div>
					<div v-if="scope.row.status == 1 && isExamine && isRecheck == false">不可操作</div>
					<div v-if="scope.row.status == 0 && isRecheck && isExamine == false">不可操作</div>
					<div v-if="scope.row.status == 3">不可操作</div>


					<!-- <div v-if="scope.row.status == 1">已完成</div> -->
				
				</template>
			</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px;" background :current-page="payList.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper"
			:total="payList.total" @size-change="handleSizeChange">
		</el-pagination>

		<!-- 查看 -->
		<el-dialog title="打款凭证" :visible.sync="showContentDialog" width="500px" :close-on-click-modal="false">
			<el-carousel v-if="contentValueArr.length > 1" height="640px">
				<el-carousel-item v-for="item in contentValueArr" :key="item">
					<img :src="item" style="width: 100%;height: 640px;" />
				</el-carousel-item>
			</el-carousel>
			<img v-if="contentValueArr.length==1" :src="contentValue" style="width: 100%;height: 640px;" />
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="showContentDialog = false">关 闭</el-button>
			</span>
		</el-dialog>

		<!-- 查看收款信息 -->
		<el-dialog style="float:rigin" :title="title" :visible.sync="queryDialogVisible" width="50%"
			:close-on-click-modal="false">

			<div class="app-container" style="text-align: center;">
				<el-form size="medium">

					<!-- <div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="充值类别:" class="redItem">
							<div v-if="integralWithdrawal.cardType == 1">银行卡</div>
							<div v-if="integralWithdrawal.cardType == 2">支付宝</div>
							<div v-if="integralWithdrawal.cardType == 3">微信</div>
						</el-form-item>

						<el-form-item v-if="integralWithdrawal.cardUserName" label="姓名:" class="redItem">
							{{integralWithdrawal.cardUserName}}
						</el-form-item>

					</div> -->

					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item v-if="integralWithdrawal.cardBank" label="充值金额:" class="redItem">
							{{integralWithdrawal.cardBank}}
						</el-form-item>	
						<!-- <el-form-item v-if="integralWithdrawal.cardBank" label="开户银行:" class="redItem">
							{{integralWithdrawal.cardBank}}
						</el-form-item>
							<!- -->
						<el-form-item v-if="integralWithdrawal.cardSubbranch" label="开户支行:" class="redItem">
							{{integralWithdrawal.cardSubbranch}}
						</el-form-item> 
					</div>

					<div style="display: flex;align-items: center;justify-content: space-between;">

						<el-form-item v-if="integralWithdrawal.cardNo" label="账号:" class="redItem">
							{{integralWithdrawal.cardNo}}
						</el-form-item>
					</div>

					<div style="display: flex;align-items: center;justify-content: space-between;">

						<el-form-item v-if="integralWithdrawal.cardImg" label="收款二维码图片:" class="redItem">
							<img :src="integralWithdrawal.cardImg" width="60%" />
						</el-form-item>
					</div>

					<div v-if="type == 2 || type == 3" style="display: flex;align-items: center;justify-content: space-between;">

						<el-form-item :label-width="formLabelWidth" label="充值金额:">
							<el-input type="number"  />
						</el-form-item>

						<el-form-item :label-width="formLabelWidth" label="打款凭证:">
							<template >
								<img v-if="integralWithdrawal.systemDocuments" :src="integralWithdrawal.systemDocuments" width="40%" />
								<div v-else>请上传图片</div>
							</template>
						</el-form-item>
					</div>

					<div v-if="type == 4" style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="驳回原因:" class="redItem" style="width: 100%;">
							<el-input style="width: 100%;" v-model="integralWithdrawal.reason" placeholder="请输入驳回原因">
							</el-input>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div style="text-align: center;">
				<el-button v-if="type == 2 || type == 3" type="primary" @click="remit" :loading="remitLoading">转 帐 完 成</el-button>
				<el-button v-if="type == 1" type="primary" @click="queryDialogVisible = false">关 闭</el-button>
				<el-button v-if="type == 4" type="primary" @click="reject" :loading="bhLoading">驳 回</el-button>
				<el-button v-if="type == 2 || type == 3 || type == 4" @click="queryDialogVisible = false">取 消</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import {
		uploadFileServer
	} from "@/api/axios.js";
	var urls = uploadFileServer('integralWithdrawal');

	import {
		quillEditor
	} from 'vue-quill-editor' //调用编辑器
	import 'quill/dist/quill.core.css'
	import 'quill/dist/quill.snow.css'
	import 'quill/dist/quill.bubble.css'
	export default {
		components: {
			//使用编辑器
			quillEditor
		},
		data() {
			return {
				title: '',
				imgUrl: urls,
				fileList: [],
				username:'',
				type: 0,
				amountSum:'',
				user:'',
				loading: false,
				bhLoading:false,
				payList: [], //档位列表
				integralWithdrawal: {},
				rejectDialogVisible: false,
				queryDialogVisible: false,
				mainFormRules: {
					title: {
						required: true,
						message: "请输入账号",
						trigger: "blur"
					},
				},
				ids: '', //id
				formLabelWidth: "200px",
				page: {
					pageNum: 1,
					pageSize: 10
				},
				searchInfo: {
					cardType: '',
					status: ''
				},
				index: null,
				contentValue: "",
				showContentDialog: false,
				limtlist1: [],	// 审核
				limtlist2: [], // 复核
				isExamine: false,
				isRecheck: false,
				contentValueArr:[],

				remitLoading: false,
			};
		},
		computed: {
			editor() {
				return this.$refs.myQuillEditor.quill
			}
		},
		methods: {
			getAmount(){
				let data={
						phone: this.searchInfo.phone,
						cardType: this.searchInfo.cardType,
						status: this.searchInfo.status,
						username:this.searchInfo.username,
						userId: this.searchInfo.userId,
						orderType: this.searchInfo.orderType,
						startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : "",
						cutOffTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
				}
				this.$api.getAmountSumGly(data).then(res=>{
					console.log('表格数据--',res);
					this.amountSum = res.data.data
				})
			},
			showloadFile(res) {
				if (!res) {
					return
				}
				const link = document.createElement('a');
				let blob = new Blob([res], {
					type: 'application/vnd.ms-excel'
				});
				link.style.display = 'none';
				link.href = URL.createObjectURL(blob);
				link.setAttribute('download', '充值记录' + '.xls');
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			},
			downloadFile() { //导出
				let data = {
					phone: this.searchInfo.phone,
					cardType: this.searchInfo.cardType,
					status: this.searchInfo.status,
					username:this.searchInfo.username,
					orderType: this.searchInfo.orderType,
					userId: this.searchInfo.userId,
					startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : "",
					cutOffTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
				}
				this.$api.rechargeExcelGly(data).then((res) => {
					// console.log(res.data)
					this.showloadFile(res.data)
				})
			},
			reject() {
				this.bhLoading = true;
				// console.log(scope.row.id);
				let data=this.username+'~'+this.ids
				this.$api.rechargeRejectedGly({
					reasonsforrefusal:this.integralWithdrawal.reason,
					id:this.integralWithdrawal.id,
					checkBy:data
				}).then((res) => {
				// 	console.log('res', res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						
						this.queryDialogVisible = false;
						this.integralWithdrawal={}
						this.findBypayList();
					} else {
						this.$message.error(res.message);
					}
					this.bhLoading = false;
				})
				// this.$api.integralWithdrawalReject(this.integralWithdrawal).then((res) => {
				// 	console.log('res', res)
				// 	if (res.state == 'success') {
				// 		this.$message({
				// 			message: res.message,
				// 			type: 'success'
				// 		});
				// 		this.queryDialogVisible = false;
				// 		this.findpayList();
				// 	} else {
				// 		this.$message.error(res.message);
				// 	}
				// })
			},
			remit() {
				this.remitLoading = true;
				this.$api.haveMoneyGly(this.integralWithdrawal).then((res) => {
					// console.log('res', res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.queryDialogVisible = false;
						this.findBypayList();
					} else {
						this.$message.error(res.message);
					}
					this.remitLoading = false;
				})
			},
			queryIntegralWithdrawal(e, type, title) {
				console.log(e,type, '123',this.integralWithdrawal);
				this.fileList = [];
				this.title = title;
				this.queryDialogVisible = true;
				this.type = type;
				this.integralWithdrawal.id=e
				
			},
			handleRemove(file, fileList) {
				//console.log(file, fileList);
			},
			
			handlePreview(file) {
				//console.log(file);
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${file.name}？`);
			},
			onSuccess(response, file, fileList) {
				// console.log(response);
				var integralWithdrawal = {
					id: this.integralWithdrawal.id,
					cardType: this.integralWithdrawal.cardType,
					cardUserName: this.integralWithdrawal.cardUserName,
					cardBank: this.integralWithdrawal.cardBank,
					cardSubbranch: this.integralWithdrawal.cardSubbranch,
					cardNo: this.integralWithdrawal.cardNo,
					cardImg: this.integralWithdrawal.cardImg,
					systemDocuments: response.message
				}
				this.integralWithdrawal = integralWithdrawal;
			},
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.loading = true
				this.payList=[];
				let webData = {
					pageNum: 1,
					pageSize: this.page.pageSize,
					phone: this.searchInfo.phone,
					cardType: this.searchInfo.cardType,
					status: this.searchInfo.status,
					
					orderType: this.searchInfo.orderType,
					startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : "",
					cutOffTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
				}
				this.getAmount()
				// console.log(webData)
				this.$api.findByRechargeRecordGly({
					pageNum: 1,
					pageSize: this.page.pageSize,
					cardType:this.searchInfo.cardType,
					phone:this.searchInfo.phone,
					username:this.searchInfo.username,
					userId:this.searchInfo.userId,
					status:this.searchInfo.status,
					startTime:this.searchInfo.timer ? this.searchInfo.timer[0] : "",
					cutOffTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
				}).then((res) => {//提现申请列表
					if (res.state == 'success') {
						this.payList = res.data
					}
					this.loading = false
				})
			},
			showContent(content) {
				// console.log('点击的数据---', content)
				this.contentValue = ''
				this.contentValueArr = []
				this.contentValue = content
				this.contentValueArr = this.contentValue.split(',')
				if(content == ''){
					this.$message({
						type: 'error',
						message: '没有凭证图片!'
					});
					return
				}
				this.showContentDialog = true
			},
			
			open(id,name){
				this.$confirm('确认充值金额与凭证相符吗?', '充值', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let data=this.username+'~'+this.ids
					if(name === 'sh') {
						// 审核
					this.$api.haveMoneyGly({checkBy:data,id:id}).then(res => {
						if(res.state=='success'){
							this.$message({
								type: 'success',
								message: '充值成功!'
							});
							this.findBypayList();
						}
					})
					}else {
						console.log(222)
						// 复核
						this.$api.haveMoneyGly({checkBy:data,id:id}).then(res => {
						if(res.state=='success'){
							this.$message({
								type: 'success',
								message: '充值成功!'
							});
							this.findBypayList();
						}else {
							this.$message({
								type: 'error',
								message: '操作失败'
							});
						}
					})
					}
				
				
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消充值'
					})
				})
				
			},
			//编辑弹框
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			formartStartDate(row, column) {
				var ymdhis = "";
				if (row) {
					var time = new Date(row.startDate);
					ymdhis += time.getFullYear() + "-";
					ymdhis += ((time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) : (time.getMonth() + 1)) + "-";
					ymdhis += (time.getDate() < 10 ? '0' + time.getDate() : time.getDate()) + ' ';
					ymdhis += (time.getHours() < 10 ? '0' + time.getHours() : time.getHours()) + ":";
					ymdhis += (time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()) + ":";
					ymdhis += (time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds());
					return ymdhis;
				} else {
					return '无';
				}
			},
			formartDate(row, column) {
				var ymdhis = "";
				if (row) {
					var time = new Date(row.endDate);
					ymdhis += time.getFullYear() + "-";
					ymdhis += ((time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) : (time.getMonth() + 1)) + "-";
					ymdhis += (time.getDate() < 10 ? '0' + time.getDate() : time.getDate()) + ' ';
					ymdhis += (time.getHours() < 10 ? '0' + time.getHours() : time.getHours()) + ":";
					ymdhis += (time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()) + ":";
					ymdhis += (time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds());
					return ymdhis;
				} else {
					return '无';
				}

			},
			pageChange(data) {
				this.page.pageNum = data
				this.findBypayList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.findBypayList()
			},
			findBypayList() {
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					cardType:this.searchInfo.cardType,
					phone:this.searchInfo.phone,
					username:this.searchInfo.username,
					userId:this.searchInfo.userId,
					status:this.searchInfo.status,
					startTime:this.searchInfo.timer ? this.searchInfo.timer[0] : "",
					cutOffTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
				}
				this.$api.findByRechargeRecordGly(data).then((res) => { //提现申请列表
					if (res.state == 'success') {
						console.log('表格shuju--',res.data.list)
						this.payList = res.data
						this.loading = false
						this.$api.getUserInfo().then(res=>{
							// console.log(res.data.username);
							res.data=JSON.parse(this.$decrypt(res.data)).data
							this.username=res.data.username
							this.ids=res.data.id
							console.log(this.ids,this.username);
							console.log(this.limtlist2,this.limtlist1)
							// this.ids = 36
							
							this.isExamine = this.limtlist1.some(item => {
								return item == this.ids
							})
							this.isRecheck = this.limtlist2.some(item => {
								return item == this.ids
							})
							console.log('管理员id',this.ids)
							console.log('审核',this.isExamine, '复核',this.isRecheck)
						})
					}
				})
			
				
			}
		},
		created() {
			// "可审核会员提交凭证的充值管理员ID"
			this.$api.byKey({key:'SYS_CHECK_RECHARGE'}).then(res=>{
					res=JSON.parse(this.$decrypt(res.data))
					if(res.state == 'success'){
						this.limtlist1 = (res.data.settingValue.split(','))
					}
				})
				// 可复核会员提交凭证的充值管理员ID
				this.$api.byKey({key:'SYS_REVIEW_RECHARGE'}).then(res=>{
					res=JSON.parse(this.$decrypt(res.data))
					if(res.state == 'success'){
						// console.log(res);
						this.limtlist2 = (res.data.settingValue.split(','))
						// console.log(this.limtlist2)
					}
				})
			this.getAmount()
			this.findBypayList();	
			// console.log('2',this.ids,this.username);
	
		},
	};
</script>

<style>
	.demo-table-expand {
		font-size: 0;
		margin-left: 30px;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.lpc-quill img {
		width: 100px;
		height: 120px;
	}

	.lpc-quill-en img {
		width: 100px;
		height: 120px;
	}
</style>